export enum LightModernPaletteVariantType {
  Graphite = 'graphite',
  Lavender = 'lavender',
}
